module.exports = __webpack_public_path__ + "static/media/wordpress-logo.db6b92ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/wordpress-logo.svg
// module id = 84
// module chunks = 0